import { Link } from 'react-router-dom';

const columns = [
  {
    title: 'Forex พื้นฐาน',
    links: [
      { label: 'คำศัพท์ Forex ทั้งหมด', to: '/glossary' },
      { label: 'Forex คืออะไร?', to: '/what-is-forex' },
      { label: 'คู่เงิน', to: '/currency-pairs' },
      { label: 'Pip', to: '/what-is-pip' },
      { label: 'Spread', to: '/what-is-spread' },
      { label: 'Leverage', to: '/what-is-leverage' },
    ],
  },
  {
    title: 'วิธีเทรด Forex',
    links: [
      { label: 'วิธีเทรด Forex ทั้งหมด', to: '/forex-trading' },
      { label: 'เปิดออเดอร์', to: '/how-to-place-order' },
      { label: 'Stop Loss', to: '/stop-loss-take-profit' },
      { label: 'Take Profit', to: '/stop-loss-take-profit' },
    ],
  },
  {
    title: 'MT4 / MT5',
    links: [
      { label: 'MT4', to: '/mt4-guide' },
      { label: 'MT5', to: '/mt5-guide' },
      { label: 'คู่มือ MT4', to: '/mt4-guide' },
      { label: 'คู่มือ MT5', to: '/mt5-guide' },
    ],
  },
  {
    title: 'การวิเคราะห์',
    links: [
      { label: 'Technical Analysis', to: '/forex-technical-analysis' },
      { label: 'Indicators', to: '/technical-indicators' },
      { label: 'Support & Resistance', to: '/support-resistance' },
      { label: 'Risk Management', to: '/risk-management-basics' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-20 md:mt-28 border-t border-background-200 bg-primary-50/60">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-2 gap-x-6 gap-y-8 sm:gap-10 lg:grid-cols-[1.4fr_repeat(4,1fr)]">
          <div className="col-span-2 max-w-sm lg:col-span-1">
            <img
              src="/logo.png"
              alt="Forex Academy Thailand"
              width={180}
              height={60}
              className="h-auto w-[180px]"
            />
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              แพลตฟอร์มให้ความรู้ Forex ภาษาไทยสำหรับมือใหม่ เรียนรู้ตั้งแต่พื้นฐานจนเข้าใจวิธีเทรดและการบริหารความเสี่ยง
              เน้นความเข้าใจและความรับผิดชอบต่อความเสี่ยง ไม่ใช่การชักชวนลงทุน
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-sm font-semibold text-foreground-950">{col.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link, index) => (
                  <li key={`${link.to}-${index}`}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-primary-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-relaxed text-foreground-500">
            © {new Date().getFullYear()} Forex Academy Thailand · เนื้อหาเพื่อการศึกษาเท่านั้น การเทรดมีความเสี่ยง
            โปรดศึกษาข้อมูลก่อนตัดสินใจ
          </p>
          <div className="flex items-center gap-4 text-foreground-500">
            <span className="flex items-center gap-1.5 text-xs font-medium">
              <i className="ri-shield-check-line text-base text-primary-600" />
              เน้นความเสี่ยง
            </span>
            <span className="flex items-center gap-1.5 text-xs font-medium">
              <i className="ri-book-open-line text-base text-primary-600" />
              เพื่อการศึกษา
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}